import router from '@/router/router';
import { success, error } from '@/helpers/utils';

export const Package = {
    state: {},
    mutations: {},
    getters: {
        hasPackageStarter(state, getters, rootState) {
            if (
                rootState.deha.user &&
                rootState.deha.user.paket &&
                rootState.deha.user.paket == '1'
            ) {
                return true;
            }
            return false;
        },
        hasPackageBasic(state, getters, rootState) {
            if (
                rootState.deha.user &&
                rootState.deha.user.paket &&
                rootState.deha.user.paket == '2'
            ) {
                return true;
            }
            return false;
        },
        hasPackageChangeRequestedStarter(state, getters, rootState) {
            if (
                rootState.deha.user &&
                rootState.deha.user.paket &&
                rootState.deha.user.paket == '1' &&
                getters.getPages &&
                Object.values(getters.getPages).filter(
                    (i) => !['home', 'imprint', 'privacy'].includes(i.type)
                ).length > 0
            ) {
                return true;
            }
            return false;
        },
        hasPackageChangeRequestedBasic(state, getters, rootState) {
            if (
                rootState.deha.user &&
                rootState.deha.user.paket &&
                rootState.deha.user.paket == '2' &&
                getters.getPages &&
                Object.values(getters.getPages).length > 0 &&
                Object.values(getters.getPages).filter(
                    (i) => !['home', 'imprint', 'privacy'].includes(i.type)
                ).length === 0
            ) {
                return true;
            }
            return false;
        },
        hasPackageChangeRequested(state, getters) {
            return (
                getters.hasPackageChangeRequestedStarter || getters.hasPackageChangeRequestedBasic
            );
        }
    },
    actions: {
        async checkForPackageChange(context) {
            if (!context.getters.hasPackageChangeRequested) {
                return;
            }
            if (context.getters.hasPackageChangeRequestedBasic) {
                await context.dispatch('removeProp', {
                    source: 'tecpage.user.settings.misc.wizard_finish'
                });
            }
            if (context.getters.hasPackageChangeRequestedStarter) {
                await context.dispatch('downgradeToStarter');
            }
            await context.dispatch('saveAllData');
        },
        // this is only allowed for testing purposes
        async changePackageRequest(context, chosenPackage) {
            try {
                await context.dispatch('setProp', {
                    source: 'deha.user.paket',
                    value: chosenPackage
                });
                await context.dispatch('saveAllData');
                await context.dispatch('checkForPackageChange');
                if (chosenPackage == 2) {
                    await new Promise((resolve) => {
                        router.push({ name: 'wizard' }, () => {
                            resolve();
                        });
                    });
                }
                success('Erfolgreich Tarifwechsel angefordert!');
            } catch (e) {
                error('Es ist ein Fehler aufgetreten!');
                console.error(e);
                return Promise.reject();
            }
        }
    }
};
